import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCardVisa = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#00579F",
			d: "M8.2898 7.20502L7.2998 12.785H8.8298L9.7298 7.20502H8.2898Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00579F",
			d: "M12.6096 9.45502C12.1596 9.18502 11.7996 9.00502 11.7996 8.73502C11.7996 8.46502 12.0696 8.28502 12.6096 8.28502C13.0596 8.28502 13.4196 8.37502 13.6896 8.46502L13.7796 8.55502L14.0496 7.29502C13.7796 7.20502 13.3296 7.02502 12.6996 7.02502C11.2596 7.02502 10.2696 7.83502 10.2696 8.91502C10.2696 9.72502 10.9896 10.175 11.5296 10.445C12.0696 10.715 12.2496 10.895 12.2496 11.165C12.2496 11.525 11.7996 11.705 11.3496 11.705C10.8096 11.705 10.4496 11.615 9.99965 11.435L9.81965 11.345L9.63965 12.605C9.99965 12.785 10.6296 12.875 11.2596 12.875C12.7896 12.875 13.7796 12.155 13.7796 10.985C13.8696 10.355 13.5096 9.81502 12.6096 9.45502Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00579F",
			d: "M17.8303 7.20502H16.6603C16.3003 7.20502 16.0303 7.29502 15.9403 7.65502L13.7803 12.785H15.3103C15.3103 12.785 15.5803 12.065 15.5803 11.975C15.7603 11.975 17.2003 11.975 17.4703 11.975C17.4703 12.155 17.6503 12.785 17.6503 12.785H19.0003L17.8303 7.20502ZM16.0303 10.805C16.1203 10.445 16.5703 9.18502 16.5703 9.18502C16.5703 9.18502 16.6603 8.82502 16.7503 8.64502L16.8403 9.09502C16.8403 9.09502 17.1103 10.445 17.2003 10.715C17.0203 10.805 16.3003 10.805 16.0303 10.805Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00579F",
			d: "M6.13 7.20499L4.69 11.075L4.51 10.265L4.06 7.65499C3.97 7.29499 3.7 7.20499 3.34 7.20499H1V7.29499C1.54 7.47499 2.08 7.65499 2.53 7.92499L3.79 12.785H5.32L7.57 7.11499H6.13V7.20499Z"
		})
	]
});
const ForwardRef = forwardRef(SvgIconCardVisa);
export default ForwardRef;
